// lib
import React from 'react'
import PropTypes from 'prop-types'

// components
import { Dropdown } from 'primereact/dropdown'

import ControlsComponents from '@aytm/app/stats/page/question-views/oe/components/ControlsComponents'

// styles
import style from '@aytm/app/stats/page/question-views/cn/styles/Controls.module.scss'

const Controls = ({ model, data, disabled, onConfigChange, ...props }) => {
  const { config, answerVariants } = model

  const answerOptions = [
    { key: '*', text: 'Entire conversation overview' },
    ...answerVariants.map(answerVariant => {
      return {
        key: answerVariant.id,
        text: answerVariant.text,
        index: `A${answerVariant.position}`
      }
    })
  ]

  const answerItemTemplate = option =>
    option.hidden ? null : (
      <>
        <b>{option.index ? option.index + ': ' : ''}</b>
        <span dangerouslySetInnerHTML={{ __html: option.text }}></span>
      </>
    )
  const answerValueTemplate = (option, _props) =>
    option ? (
      <>
        <b>{option.index ? option.index + ': ' : ''}</b>
        <span dangerouslySetInnerHTML={{ __html: option.text }}></span>
      </>
    ) : (
      <span dangerouslySetInnerHTML={{ __html: _props.placeholder || 'Select...' }}></span>
    )

  const onChange = event => onConfigChange('ids', '*' == event.value ? null : event.value)

  return disabled ? null : (
    <div className={`${style.component} p-fluid`}>
      <div className={`${style.filter} p-field p-col`}>
        <Dropdown
          className="p-dropdown-rounded"
          value={config.ids ? config.ids : '*'}
          options={answerOptions}
          optionValue="key"
          optionLabel="text"
          optionDisabled="disabled"
          itemTemplate={answerItemTemplate}
          valueTemplate={answerValueTemplate}
          fixedDropdownDir="bottom"
          disabled={data.controls.config.filter?.disabled}
          onChange={data.controls.config.filter?.disabled ? null : onChange}
        />
      </div>
      <div className={`${style.controls} p-fluid p-col`}>
        <ControlsComponents model={model} data={data} onConfigChange={onConfigChange} {...props} />
      </div>
    </div>
  )
}

Controls.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  disabled: PropTypes.bool,
  onConfigChange: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
